var $baaf410a37b59762$exports = {};
$baaf410a37b59762$exports = {
    "info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "negative": `\u{41F}\u{43E}\u{43C}\u{438}\u{43B}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{456}\u{448}\u{43D}\u{43E}`
};


export {$baaf410a37b59762$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
